import React from "react";
import { View, Text } from "@react-pdf/renderer";
import Styles from "../Styles";
import { LabelLineRow } from "./FormFields";

const MyWill = ({ primaryColor = "081e56" }) => {
  const styles = Styles(primaryColor);
  return (
    <View style={{ ...styles.FlexStartColumn, gap: 0 }}>
      <Text style={styles.ContentSemiBold}>My Will</Text>
      <View style={styles.panel}>
        <View style={styles.row}>
          <View style={{ ...styles.col, gap: 0 }}>
            <Text style={styles.LabelSmallSemiBold}>
              The Original of my Will is Located
            </Text>
            <LabelLineRow styles={styles} label="" lines={1} />
          </View>
          <View style={{ ...styles.col, gap: 0 }}>
            <Text style={styles.LabelSmallSemiBold}>
              The Will was Drawn up By
            </Text>
            <LabelLineRow styles={styles} label="" lines={1} />
          </View>
        </View>
        <View style={styles.cols}>
          {/* Row 1 */}
          <View style={styles.row}>
            <View style={styles.col}>
              <LabelLineRow styles={styles} label="The Will is Dated" />
            </View>
            <View style={styles.col}>
              <LabelLineRow styles={styles} label="Address" lines={2} />
              <LabelLineRow styles={styles} label="The Executors are" />
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default MyWill;
